import Services from './base-services'

const service = new Services('teachers-webinars')

export default {
    getWebinars() {
        return service.get('', undefined, true)
    },
}
